<template>
  <div>
    <v-dialog v-model="dialog" 
      persistent
      width="500">
      <v-card class="border-radius box-shadow">
        <v-card-text class="text-second pa-5 px-7">
          Apakah anda yakin mengkonfimasi pembayaran <b>{{ detail.additional_cost_label }}</b> ?
        </v-card-text>
        <v-card-text>
          <quill-editor 
            ref="myTextEditor"
            :options="option"
            v-model="detail.additional_cost_desc">
          </quill-editor>
        </v-card-text>
        <v-divider class="mx-4 my-2"/>
        <v-card-actions class="pa-5">
          <v-spacer/>
          <v-btn
            outlined
            :color="style.primary"
            class="text-capitalize green--text mx-1"
            :disabled="process.form"
            :loading="process.form"
            @click="confirmation">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn
            outlined
            color="red"
            class="text-capitalize red--text mx-1"
            :disabled="process.form"
            @click="dialog = false; detail = {};">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" class="py-0">
        <v-card flat min-height="800">
          <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'px-0':''">
            <v-row>
              <v-col cols="12" md="5" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'pb-0':'py-0'">
                
              </v-col>
              <v-col cols="12" md="4" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'pb-0':'py-0'">
                <v-text-field
                  outlined
                  dense
                  :hide-details="true"
                  placeholder="Cari Biaya Lain-lain / Titipan . . ."
                  clearable
                  :color="style.primary"
                  v-model="filter.title"
                  @click:clear="filter.title = ''; fetch();"
                  v-on:keyup.enter="fetch()"
                  prepend-inner-icon="mdi-magnify">
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'pb-0':'py-0'">
                <v-select
                  dense
                  outlined
                  :items="[
                    {
                      label: 'Semua',
                      value: ''
                    },
                    {
                      label: 'Menunggu Konfirmasi Finance',
                      value: 'confirmed'
                    },
                    {
                      label: 'Terbayar',
                      value: 'close'
                    }
                  ]"
                  item-text="label"
                  item-value="value"
                  item-color="light-green lighten-2"
                  v-model="filter.status"
                  v-on:change="fetch()"
                  label="Status"
                  :color="style.primary"
                  hide-details>
                  <template v-slot:append>
                    <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mx-4"/>
          <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'px-0 py-0':'py-0'" style="min-height: 600px;">
            <v-skeleton-loader
              :loading="process.run"
              transition="scale-transition"
              :tile="false"
              type="table-tbody">
              <v-simple-table>
                <template v-slot:default>
                  <thead v-if="!process.run && list.length > 0">
                    <tr>
                      <th class="text-left pl-0" width="300">Proyek</th>
                      <th class="text-left">Unit / Blok</th>
                      <th class="text-left">Konsumen</th>
                      <th class="text-right">Biaya Lain-lain</th>
                      <th class="text-left">Dibayarkan</th>
                      <th class="text-left" width="200">Status</th>
                      <th class="text-left"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr 
                      v-for="(item, index) in list" 
                      :key="index">
                      <td class="text-second pl-0">
                        {{ item.transaction_project_name }}
                      </td>
                      <td class="text-second">
                        <p class="mb-1">
                          {{ item.unit_type_name }} - {{ item.transaction_unit_name }}
                        </p>
                        <p class="text-third font-weight-bold mb-0" style="font-size: 10px;">
                          {{ parseInt(item.transaction_unit_price) | price }}
                        </p>
                      </td>
                      <td class="text-second">
                        <p class="mb-1">
                          {{ item.transaction_user_name }}
                        </p>
                        <p class="text-third font-weight-bold mb-0" style="font-size: 10px;">
                          {{ item.transaction_user_mobilephone }}
                        </p>
                      </td>
                      <td class="text-second text-right">
                         {{ parseInt(item.additional_cost_value) | price }}
                      </td>
                      <td class="text-second text-capitalize">
                        <span v-if="item.additional_cost_paydate !== ''">
                          {{ item.additional_cost_paydate | date }}
                        </span>
                        <span v-else>
                          -
                        </span>
                      </td>
                      <td class="font-weight-bold text-capitalize"
                        :class="item.additional_cost_status === 'open' ? 'red--text' : item.additional_cost_status === 'confirmed' ? 'color-default' : 'teal--text'">
                        {{ item.additional_cost_status === 'open' ? 'Belum Dibayar' : item.additional_cost_status === 'confirmed' ? 'Menunggu Konfirmasi Finance' : 'Terbayar' }}
                      </td>
                      <td class="text-right pr-0">
                        <v-btn v-if="item.additional_cost_status === 'confirmed' && (user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('finance')) && item.transaction_is_canceled === '0'"
                          small
                          width="120"
                          outlined
                          :color="style.primary"
                          class="text-capitalize mx-1"
                          @click="dialog = true; detail = item;">
                          <v-icon small class="mr-1">mdi-check</v-icon>
                          Konfirmasi
                        </v-btn>
                        <v-btn v-if="item.transaction_is_canceled === '0'"
                          small
                          width="120"
                          outlined
                          color="grey"
                          class="text-capitalize mx-1"
                          :href="`/project/unit/transaction/booking/${item.booking_id}?transaction=${item.transaction_id}&unit=${item.transaction_unit_id}`"
                          target="_blank">
                          <v-icon small class="mr-1">mdi-information-outline</v-icon>
                          Info Booking
                        </v-btn>
                        <span class="red--text font-weight-bold" v-if="item.transaction_is_canceled === '1'">
                          Booking Dibatalkan
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-skeleton-loader>
            <div class="d-flex align-center text-center text--secondary my-12 py-12" style="min-height: 550px;" v-if="!process.run && pagination.total_page < 1">
              <v-img 
                class="my-12"
                contain
                width="200"
                height="200"
                :src="require('../../assets/404/404.svg')">
              </v-img>
            </div>
            <v-divider/>
          </v-card-text>
          <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'pt-0':''">
            <v-row justify="end" align="center" v-if="pagination.total_page > 1">
              <v-col cols="12" md="2" class="d-flex align-center justify-end">
                <v-btn
                  :color="style.primary"
                  :disabled="pagination.current === 1"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0 mr-3"
                  @click="selected.pagination = 1">
                  <v-icon>mdi-chevron-double-left</v-icon>
                </v-btn>
                <v-btn
                  color="#263238"
                  :disabled="pagination.current < 2"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0"
                  @click="selected.pagination = selected.pagination-1">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <div class="mx-5" style="width: 75px;">
                  <v-autocomplete
                    v-model="selected.pagination"
                    :items="pagination.detail"
                    color="#263238"
                    auto-select-first
                    outlined
                    dense
                    single-line
                    hide-details
                    hide-selected>
                    <template v-slot:selection="{ item }">
                      {{ item }}
                    </template>
                  </v-autocomplete>
                </div>
                <v-btn
                  color="#263238"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0"
                  :disabled="pagination.current >= pagination.total_page"
                  @click="selected.pagination = selected.pagination+1">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                <v-btn
                  :color="style.primary"
                  :disabled="pagination.current === pagination.total_page"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0 ml-3"
                  @click="selected.pagination = pagination.total_page">
                  <v-icon>mdi-chevron-double-right</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../service/Axios";
  export default {
    data () {
      return {
        option: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline'],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }]
            ]
          },
          placeholder: 'Keterangan'
        },
        dialog: false,
        selected: {
          pagination: 1
        },
        filter: {
          title: '',
          status: ''
        },
        page: 1,
        list: [],
        pagination: {},
        detail: {},
        process: {
          run: false,
          form: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    components: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
      'selected.pagination': function(val) {
        this.fetch(val)
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch(p) {
        this.process.run = true

        let params = {
          page: p,
          limit: 12,
          search: this.filter.title,
          filter: [
            {
              type: 'string',
              field: 'additional_cost_status',
              value: this.filter.status
            }
          ]
        }

        await get(`auth/transaction/additional-cost/list`, { params })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.run = false
            this.list = res.data.results
            this.pagination = res.data.pagination
            this.pagination.current = parseInt(this.pagination.current)
          }
        })
      },
      async confirmation() {
        this.error.message = ''
        this.process.form = true

        let form = {
          additional_cost_id: this.detail.additional_cost_id,
          paydate: '',
          desc: this.detail.additional_cost_desc,
          status: this.user.user_company_roles_name.includes('superuser') || this.user.user_company_roles_name.includes('finance') ? 'close' : 'confirmed'
        }

        await post(`auth/transaction/additional-cost/update-payment`, {
          data: form
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.process.form = false
            this.dialog = false
            this.detail = {}

            window.open(res.data.url, '_blank')

            this.fetch()
          } else {
            this.process.run = false
            this.error.message = res.msg
          }
        })
      }
    }
  }
</script>